const migrations = {
  0: state => ({
    ...state,
  }),
  1: state => ({
    ...state,
    loan: {
      ...state.loan,
      isDataNotMatchError: state.loan.isDataNotMatchError || false,
    },
  }),
  2: state => ({
    ...state,
    authentication: {
      isAuthenticated: state.authentication.isAuthenticated || false,
      phone_number: state.authentication.phone_number || '',
      transaction_id: state.authentication.transaction_id || '',
    },
  }),
  3: state => ({
    ...state,
    profile: {
      ...state.profile,
      changePhoneNumberError: state.profile.changePhoneNumberError || '',
    },
  }),
  4: state => ({
    ...state,
    loan: {
      ...state.loan,
      old_package_id: state.loan.old_package_id || null,
    },
  }),
  5: state => ({
    ...state,
    profile: {
      ...state.profile,
      phoneNumberNotMatchError: state.profile.phoneNumberNotMatchError || '',
    },
  }),
  6: state => ({
    ...state,
    profile: {
      ...state.profile,
      tooManyAttemptError: state.profile.tooManyAttemptError || '',
      wrongOTPError: state.profile.wrongOTPError || '',
    },
  }),
  7: state => ({
    ...state,
    profile: {
      ...state.profile,
      domicileOutOfCoverageError:
        state.profile.domicileOutOfCoverageError || '',
    },
  }),
  8: state => ({
    ...state,
    profile: {
      ...state.profile,
      tooManyAttemptResendError: state.profile.tooManyAttemptResendError || '',
    },
  }),
  9: state => ({
    ...state,
    authentication: {
      ...state.authentication,
      otp_delivery: state.authentication.otp_delivery || 'whatsapp',
      otp_token: state.authentication.otp_token || '',
    },
  }),
  10: state => ({
    ...state,
    profile: {
      ...state.profile,
      personalInformationData:
        {
          ...state.profile.personalInformationData,
          email: state.profile.personalInformationData.email || null,
        } || null,
    },
  }),
  11: state => ({
    ...state,
    profile: {
      ...state.profile,
      isDigitalApplication: state.profile.isDigitalApplication || null,
    },
  }),
  12: state => ({
    ...state,
    loan: {
      ...state.loan,
      is_update_to_vehicle_info_provided:
        state.loan.is_update_to_vehicle_info_provided || false,
    },
  }),
  13: state => ({
    ...state,
    profile: {
      ...state.profile,

      maximumAttemptEditKTPError:
        state.profile.maximumAttemptEditKTPError || '',
    },
  }),
  14: state => ({
    ...state,
    profile: {
      ...state.profile,
      touchPointAction: state.profile.touchPointAction || '',
    },
  }),
  15: state => ({
    ...state,
    profile: {
      ...state.profile,
      geoplaceError: state.profile.geoplaceError || '',
      isOpenGeoplaceScreen: state.profile.isOpenGeoplaceScreen || false,
    },
  }),
  16: state => ({
    ...state,
    profile: {
      ...state.profile,
      agentNotFoundError: state.profile.agentNotFoundError || '',
    },
  }),
  17: state => ({
    ...state,
    profile: {
      ...state.profile,
      agentNotFoundError: {
        code: state.profile.agentNotFoundError.code || '',
        data: {
          applicationId:
            state.profile.agentNotFoundError.data.applicationId || '',
          marketingId: state.profile.agentNotFoundError.data.marketingId || '',
          branchCode: state.profile.agentNotFoundError.data.branchCode || '',
          errorCode: state.profile.agentNotFoundError.data.errorCode || '',
        },
      },
    },
  }),
  18: state => ({
    ...state,
    authentication: {
      ...state.authentication,
      group_id: state.authentication.group_id || '',
      group_code: state.authentication.group_code || '',
    },
  }),
  19: state => ({
    ...state,
    authentication: {
      ...state.authentication,
      isPostSubmissionLogin:
        state.authentication.isPostSubmissionLogin || false,
    },
  }),
  20: state => ({
    ...state,
    authentication: {
      ...state.authentication,
      isAllowChangePhoneNumber:
        state.authentication.isAllowChangePhoneNumber || false,
    },
  }),
  21: state => ({
    ...state,
    profile: {
      ...state.profile,
      maxAgeApplicantKTPError: state.profile.maxAgeApplicantKTPError || '',
    },
  }),
  22: state => ({
    ...state,
    profile: {
      ...state.profile,
      applicationNumber: state.profile.applicationNumber || '',
    },
  }),
  23: state => ({
    ...state,
    profile: {
      ...state.profile,
      leadExpiredError: state.profile.leadExpiredError || null,
    },
  }),
};

export default migrations;
